import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../demo.service';
import { DataService } from '../system-log-manager/data.service'; 

// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, RowSelectEventArgs, SelectionSettingsModel, SortService, TextWrapSettingsModel, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

// import {Column } from '@syncfusion/ej2-ng-grids';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { HotToastService } from '@ngneat/hot-toast';
import { Brand } from 'src/app/api/brand';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-system-investigation',
  templateUrl: './system-investigation.component.html',
  styleUrls: ['./system-investigation.component.scss'],
  providers: [DataService]
})
export class SystemInvestigationComponent implements OnInit {


  // public logs$: Observable<SystemLog[]>;
  // Normal Layout
  logs$: Observable<any>;
  logs: any;

  // for grid so it has change events.
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  @ViewChild('grid')
  public grid: GridComponent;

  @ViewChild('grid2')
  public grid2: GridComponent;

  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
    // TABS sets the selected
    @ViewChild('staticTabs') staticTabs!: TabsetComponent;
    selected_tab?: number;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 2500 }; 
  public filterOptions: FilterSettingsModel;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  searchOptions: {};
  initialPage: { pageSize: number; };
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  live_IP_Access_log_data: any;
  formatOptions: { type: string; format: string; };
  logs_search: any = [];

  combo_model: Brand;
  search_model: SystemLog;
  brands_client: any;
  brands_agent: any;
  users: Object;
  brand_types: any;
  user_levels: any;
  system_log_types: any;
  model: any;
  sent_model: ppsDistrHubActionList;
  selectedrecords: object[];

  today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison
  action_lists: any;
  action_lists_table: any;
  chosenActionListID: any;
  get_latest_action_ist_id: any;
  action_list_today: Object;
  action_list_today_ID: any;
  modalRef: any;

  // Need to create a different type of data service?
  // see: https://ej2.syncfusion.com/angular/documentation/grid/observables/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.service.execute(state);
  }

// ... additions for datepicker column for sycfusion grid
  //public data: Object[];
  //public ddldata: Object[];
  //public pageOptions: Object;
  public category: string[];
  //public templateOptionsDate: IFilterUI;
  //public elem1: HTMLElement;
  //public datePickerObj: DatePicker;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  DialogObj: any;

  search_results: any;

  // My Custom Logger Class.PHP - Same as BackVault.
  private _jsonURL_slim_api = 'https://api.sharmans.net.au/slimapp/public/' + 'live_IP_Access_log.txt';

  constructor(
    private _demoService: DemoService,
    public service: DataService,
    private route: ActivatedRoute, private router: Router,
    public gfunc: GlobalFunctionsService,
    private http: HttpClient,
    public toastr: HotToastService,
    public datepipe: DatePipe,
    private modalService: BsModalService,
  ) {
   // this.logs$ = this._demoService.fetchSystemLog(); loads the observable without a function

    // Setup Grid
    // , {
      // text: 'TRY ME!',
      // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
    // }
    this.toolbarOptions = ['ExcelExport', 'Search'];
    // this.toolbar = [
    // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  //  this.initialPage = { pageSize: 100 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    // this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy';
     this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };


    this.initialPage = { pageSize: 2500 };
    this.filterOptions = {
    type: 'Menu'
    };

    // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
    this.groupOptions = { }; // sets auto grouping for the grid

    this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    // this.filter = { params: { format: this.dateFormat } };
    // this.sortOptions = { columns: [ ] };

    //checkbox selection options
    this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'
    // this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 

    
    this.wrapSettings = { wrapMode: 'Content' };
    this.searchOptions = {  };



// More Date Upgards 2022 syncfsion grid
    // this.templateOptionsDate = {
    //   create: () => {
    //     this.elem1 = document.createElement('input');
    //     return this.elem1;
    //   },
    //   write: (args) => {
    //     this.datePickerObj = new DatePicker({
    //       value: new Date(args.column.field),
    //       floatLabelType: 'Never',
    //       change: this.sync_changes.bind(this), // this is a function see below.
    //     });
    //     this.datePickerObj.appendTo(this.elem1);
    //   }
    // }   





// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));




  }


  
  ngOnInit() {

    // Get Slim API Logs // Did not work direct access due to cors issues..... 
    // this.getJSON().subscribe(data => {
    //   let res = data;
    //   this.live_IP_Access_log_data = res;
    //   console.log('Slim API: ' + data);
    //  });







   // const state = { skip: 0, take: 10 };
   // this.service.execute(state);


     // do a call to fetch the users on init of component
    // the fetchUsers method returns an observable
    // which we assign to the users$ property of our class
    // this.users$ = this.client.fetchUsers()
 // this.logs$ = this._demoService.fetchSystemLog(); // async instead of a function below.
  this.getLogs();
  this.search_model = new SystemLog(); // if undefined need to setup the model first.
this.search_model.limit = 200;
  this.getLogsSearch(this.search_model)
  this.getBrandsComboBoxClients(this.combo_model); // gets all brands
  this.getUsers();
  this.getBrandTypes();
  this.getFormUserLevels();
  this.getSystemLogTypes();


  this.model = new ppsDistrHubActionList();
  this.sent_model = new ppsDistrHubActionList();
  // setup the save list vars first.
  this.model.action_list_name = this.action_day_words + '-InternalInvestigation'; // set the default document Name for Today. 
 
        // set the defaults.
        this.model.action_list_type_id = '1';
        this.model.created_by = this.sessionUserId;
        this.model.updated_by = this.sessionUserId;
        this.model.is_active = '1';
        this.model.action_day_saved = this.today;
        this.model.created_date = this.today;
        this.model.updated_date = this.today;
        this.model.brand_id = this.sessionBrandId;
        this.model.user_id = this.sessionUserId;
        this.model.job_type_id = 14; // PPS DisroHub - As a default preset
        this.model.search_results_meta = this.search_results; // PPS DisroHub - As a default preset
        
        this.getActionLists() // load the Action List Drop Down and Set a Default
 
         // first Lookup and see if action lists Exists.
        this.getActionListByName(this.model.action_list_name); // was causing errors and dont reall need for SO
 
  // this.getActionLists();

  }

  getActionListByName(action_list_name){
    this._demoService.getActionListByName(action_list_name).subscribe(
      res => {this.action_list_today = res;
        let data = res[0];
        this.action_list_today_ID = data.action_list_id;
      // this.refreshGrid();
      },
      err => {
      this.toastr.error( "Sorry, we were not able to find todays list the list, it does not exist yet.");
        console.error(err.status);
              }
    );
   }
   
// syncfusion grid data function
    // sync_changes(args) {
    //   let targEle: any = parentsUntil(args.element, 'e-filtertext');
    //    let columnName : string = targEle.id.replace('_filterBarcell', '');
    //  if (args.value) {
      
    //    this.grid.filterByColumn(columnName, 'equal', args.value);
      
    //  } else {
    //   this.grid.removeFilteredColsByField(columnName);
    //  }
    // }



    public getLogsSearch(search_model) {
      this.logs_search = [];
      this._demoService.fetchSystemLogSearch(search_model)
      .pipe(
        this.toastr.observe({
          loading: 'Checking...',
          success: '🚀',
          error: '...😡...'
       })
       )
      .subscribe(
        (res) => (
          this.logs_search = res,
          this.grid2.refresh()
          ),
        (err) => console.error(err.status)
      );
    } /* */



  private getLogs() {
    this._demoService.fetchSystemLog().subscribe(
      (res) => (this.logs = res),
      (err) => console.error(err.status)
    );
  } /* */

// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  const toolbarItemId = (args?.item?.id || '').toLowerCase();
  if (toolbarItemId.endsWith('_excelexport')) {
    const query = this.grid2.renderModule.data.generateQuery();
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);
        break;
      }
    }

    new DataManager({ json: this.logs_search || [] }).executeQuery(query).then((e: any) => {
      this.grid2.excelExport({
        dataSource: e.result as object[],
        fileName: `system-investigation-${this.today_name_file}.xlsx`
      });
    }).catch(() => {
      this.grid2.excelExport({
        fileName: `system-investigation-${this.today_name_file}.xlsx`
      });
    });
  }
}
// rowDataBound(args: RowDataBoundEventArgs) {
//   const job_status = 'job_status';
//   if (args.data[job_status] === 'CLOSED') {
//       args.row.className = 'strikethrough';
//   }
// }


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid2.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}


subjectEditLink(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectView(subject_id);
}


  
refreshGrid(){ // refresh the databutton
  // this.getLogs();
  // this.grid.refresh();
  this.grid2.refresh();
};


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


// Get API Logs
public getJSON(): Observable<any> {
  return this.http.get(this._jsonURL_slim_api);
}





// grid search buttons
searchGridColStatus(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridColCreatedVia(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['created_via'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridRemaining(string) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: 'processing', ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}

searchGridColTotalAbove(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['total'], operator: 'greaterThanOrEqual', key: 65, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridMail(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'lessThanOrEqual ', key: .01, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridCP(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid2.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'greaterThanOrEqual ', key: 1, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}

clearSearchGrid() {
  this.grid2.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid2.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid2.search(searchText);

}


clickHandlerRIS() {
  this.grid2.enablePersistence = false;
  window.localStorage.setItem("gridGrid", "");
  this.grid2.destroy();
  //reloads the page
  location.reload();
}





// getReportSubjectsUrgentSearchClient(search_model) {
//   this.brand_user_join_results = [];
//   this.subjects_urgent = [];
//   this.grid.searchSettings.key = ''; // resets the grid filters and buttons
  
// //  search_model.brand_type_id = 2;
// //  search_model.access_level = 9;
//    search_model.brand_report_id = this.brand_id // so that only this client brands will show.
  
//   this._demoService.getReportSubjectsUrgentSearchClient(search_model).subscribe(
//       data => { this.brand_search = data;
//         // pass so that the dates are correct in Sync
//         // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
//         this.brand_search_results = DataUtil.parse.parseJson(data); 
//   // get the users as well and join the records together

//   // Run this function and use the same json object and keep adding or removing to it if you wish.
//   //    this.getReportUsersSearch(search_model);
  
//   // now how to join two arrays of objects.
//   // maybe pass results in to a new model.
  
//   // Count items of brand search to loop through
//                                   let  count_of_brand_items = Object.keys(this.brand_search).length;
//                                   // now loop and push to join model
//                                   for(let i=0;i < count_of_brand_items; i++) {
//                                     let res = this.brand_search_results[i];
                                  
//                                       // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
//                                       this.brand_user_join_results.push({
//                                         email_address: res.email,
//                                         first_name: res.name,
//                                         surname: res.surname,
//                                         company_name: res.name,
//                                         created: res.created,
//                                               });

//                           this.subjects_urgent.push({
//                             // email_address: res.email,
//                             // first_name: res.name,
//                             // surname: res.surname,
//                             // company_name: res.name,
//                             // created: res.created,
//                             ...this.brand_search_results[i]
//                                   });

                                  
//                                   } // end brands loop.
                                  
//                                   this.brand_user_join_results = this.brand_user_join_results;
//                                   this.subjects_urgent = this.subjects_urgent;
  
//        this.grid.refresh();
//       },
//       error => {
//       console.error('Error Loading !' + error.error);
//       console.log(error);
//       // return Observable.throw(error);
//       }

//     ); }






addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }


  getBrandsComboBoxClients(combo_model) {
    // this.combo_model.brand_id = 2;
   this._demoService.getBrands().subscribe(
      data => { this.brands_client = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // getBrandsComboBoxClients(combo_model) {
  //   // this.combo_model.brand_id = 2;
  //  this._demoService.getBrandsComboBox(combo_model).subscribe(
  //     data => { this.brands_client = data; },
  //     err => console.error(err),
  //     // () => console.log('done loading Trace Types')
  //   );
  // }
  
  getBrandsComboBoxAgents(combo_model) {
   this.combo_model.brand_id = 3;
  this._demoService.getBrandsComboBox(combo_model).subscribe(
     data => { this.brands_agent = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }
  
  
  

getUsers() {
  this._demoService.getUsers().subscribe(
     data => { this.users = data; },
     err => console.error(err),
     () => console.log('done loading users')
   );
 }
  
  
  // syncfusion dialog simple sample
  public onOpenDialog = function(event: any): void {
    this.DialogObj = DialogUtility.confirm({
      title: 'New CLient or a Login User',
      content: 'Create New - Not Currently Activated Yet!.',
      okButton: {  text: 'Ok', click: this.okClick.bind(this) },
      cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' }
  });
  }
  private okClick(): void {
   //  alert('you clicked Yes, Please! are you really really sure??? Really');
   // this.createJobSubjectsMultiple(this.JSON_job);
  // this.createJobSubjectsMultiple(this.newSubject);
   this.DialogObj.hide();
  }
  
  private cancelClick(): void {
     // alert('you clicked Cancel button');
     this.DialogObj.hide();
  }
  


  // Functions
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }


   getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }


   getSystemLogTypes() {
    this._demoService.getSystemLogTypes().subscribe(
       data2 => { this.system_log_types = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }






   rowDataBound(args: RowDataBoundEventArgs) {
    // const job_status = 'status';
    //   if (args.data[job_status] === 'completed') {
    //       args.row.className = 'text-danger';
    //   }
    //   const status = 'status'
    //   if (args.data[status] === 'completed' || args.data[status] === 'on-hold' || args.data[status] === 'cancelled' || args.data[status] === 'refunded'  ) {
    //     args.row.className = 'text-muted';
    //     // disable the check box for complete / onhold / refunded orders.
    //     // turn off for now.
    //     args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox'); 
    //     args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox') 
    //     }
  }



  // Row select event sycn grid
    //v@ https://ej2.syncfusion.com/angular/documentation/grid/selection/row-selection
    // @ 
    rowSelected(args: RowSelectEventArgs) {

    // console.log('selected data object: ' + JSON.stringify(args.data));
          //  // simply push the object/s seleceted to the  this.search_results array.
          //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
          //  this.search_results.push({
          //    ...args.data
          //  });
          // if (typeof args.data === 'object' && args.data !== null && args.data[0].id >= 0 ){
          //   console.log('We have a header object of data selected');
          // }

          //checks if single object
          if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
            if(!this.search_results){this.search_results = [];}; // detect if array exists.
            console.log('We have a single object of data selected');
              this.search_results.push({
              ...args.data
              });
          this.toastr.info( this.search_results.length + ' Order Added in the action list'); 

          }

          // if an a list of objects need to count and then loop through.
          if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
            console.log('We have a OBJECT of object of data selected');
            const count_selected = this.grid2.getSelectedRecords().length;
            // console.log('count: ' + count_selected); // both count methods work.
            // const length = Object.keys(args.data).length
            // console.log('length: ' + length);
          
            // now loop and insert individually
            if(!this.search_results){this.search_results = [];}; // detect if array exists.
            for(let i=0;i < count_selected; i++) {
              this.search_results.push({
              ...args.data[i]
              });
              }
             this.toastr.info( this.search_results.length + ' Orders Added in the action list');
            }



    const selectedrowindex: number[] = this.grid2.getSelectedRowIndexes();  // Get the selected row indexes.
    // alert(selectedrowindex); // To alert the selected row indexes.
    const selectedrecords: object[] = this.grid2.getSelectedRecords();  // Get the selected records.
    this.selectedrecords = this.grid2.getSelectedRecords();

  
    }

    // we also need to create a row deselect event to remove from args
    rowDeSelected(args: RowSelectEventArgs) {

      
      const selectedrowindex: number[] = this.grid2.getSelectedRowIndexes();  // Get the selected row indexes.
      // alert(selectedrowindex); // To alert the selected row indexes.
      const selectedrecords: object[] = this.grid2.getSelectedRecords();  // Get the selected records.
      // this.selectedrecords = this.grid.getSelectedRecords();

      // console.log('selected data object: ' + JSON.stringify(args.data));
            //  // simply push the object/s seleceted to the  this.search_results array.
          //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
          //  // clear the the search results. forst then re-add.
          //  this.search_results = [];
          //    this.search_results.push({
          //      ...args.data
          //    });

          let argData = args.data;
      if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
        console.log('We have a single object of data de-selected');
        let base_search_results = this.search_results
        
        // this.search_results = []; 
        // this.search_results.push({
        //   ...args.data
        //   });
        


          // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
          this.search_results =  this.search_results.filter(function (order) {
            // return true for salary greater than equals to 25000
            console.log('leaving IDs= ' + args.data['id'] + ' != ' + order.id);
            return order.id != args.data['id'];
          });
          this.toastr.warning( ' Order Remved from the action list'); 


      // remove
      // filter and remove the selected ones from the object first.
          // let remove_unselected = this.grid.getSelectedRowIndexes();
          // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
        
      }    


      // if an a list of objects need to count and then loop through.
      if (typeof args.data === 'object' && args.data !== null && args.data[0]  ){
        console.log('We have a OBJECT of object of data DE-selected');
        // const count_selected = this.grid.getSelectedRecords().length;
        const count_selected = selectedrecords.length;
        
        
        console.log('count: ' + count_selected); // both count methods work.
        // const length = Object.keys(args.data).length
        // console.log('length: ' + length);
      
        // now loop and insert individually
   //     this.search_results = []; 
        for(let i=0;i < count_selected; i++) {
          // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
        //   this.search_results.push({
        //  ...args.data[i]
        //   });

          // leave items where not selected 
              // this.search_results =  this.search_results.filter(function (order) {
              // // return true for salary greater than equals to 25000
              // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
              // return order.id != args.data['id'];
              // });
              // this.search_results = this.search_results;

                           // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
          this.search_results =  this.search_results.filter(function (order) {
            // return true for salary greater than equals to 25000
            console.log('leaving IDs= ' + args.data[i]['id'] + ' != ' + order.id);
            return order.id != args.data[i]['id'];
          });
         

          }

          this.toastr.warning( ' Orders Remved from the action list'); 
      
        }





    
      }

      // this will remove the object by and and 
  //  removeObjectWithId(arr, id) {
  //       // Making a copy with the Array from() method
  //       const arrCopy = Array.from(arr);
  //       const objWithIdIndex = arrCopy.findIndex((obj) => obj.id === id);
  //       arrCopy.splice(objWithIdIndex, 1);
  //       return arrCopy;
  //     }


clearSearchResults(){
  this.search_results = [];
}


getActionLists() {
  this._demoService.getActionLists().subscribe(
    data => { 
      // let res = data[0]
      this.action_lists = data;
      this.action_lists_table = this.action_lists.slice(0, 10);
    },
    error => {
       this.toastr.error( "Sorry, we were not able to get the lists");
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
    }
  );
}





sendChosenPreviewOrder(action_list_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;

  // need to filter the woo_orders model by ID and setup a variable with the Model or order to create the label.


  this.chosenActionListID = action_list_id;

  
  this.model.action_list_id = action_list_id;


     console.log('Sent Model: ' + action_list_id  );

  // Filter only active -- filter the woo orders collection already gathered from the drop down - preaty neat, preaty neat...
  // this.chosenActionListData =  this.action_lists_table.filter(function(t) {
  // return t.id == model.order_id;
  //   });


//      // Load the preview PDF
//      this.previewPDFLink = this.gfunc.WebHookAPI_PHP_Assets + '/' + model.doc_save_name + '-preview.pdf';
//      console.log('Preview FileName: ' +  this.previewPDFLink  );

//      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.previewPDFLink );

//   // model.order_id = model.order_id;
//  console.log('sending orderID: ' + model.order_id);

// // We might as well generate a new pdf while we are at it
// this.WebHookAPI_OrderLabelCreatePreview(this.chosenPreviewOrderData[0], model.order_id, this.doc_id)


}

createActionList(model) {



  // if (this.action_list_today_ID >= 1){
  //   this.toastr.warning("You Already have a an action list so Select from your saved Action Lists.");
  //   this.model.action_list_id = this.action_list_today_ID;
  //   this.search_results = [];
  //   this.refreshGrid();
  //   return;
  // }
  
        // model.search_results_meta = this.search_results as JSON; // PPS DisroHub - As a default preset 
        model.search_results_meta = JSON.stringify(this.search_results); // PPS DisroHub - As a default preset 
        // model.search_results_meta = JSON.parse(model.search_results_meta); // PPS DisroHub - As a default preset 
        
        this._demoService.createActionList(model).subscribe(
            data => {   this.get_latest_action_ist_id = data; // this is the retuned json upon creation.
            this.toastr.success('New Action list...' + this.get_latest_action_ist_id.last_insert_id + '');
            // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
            this.get_latest_action_ist_id = this.get_latest_action_ist_id.last_insert_id;
       
             // Setup annd the Currents before we redirec the page
             // Needs to be a Function to update the ObserveOnOperator.
             // this.newCTrace_id(this.latest_trace_id);
             // or this.cdata.changeCTrace_id("999");
       
            // reload the drop down with new item
            this.getActionLists();
             model.action_list_id = this.get_latest_action_ist_id;
             // insert log
            //  this.gfunc.insertLog_CreateJob(model);
            //  this.router.navigate(['/client/jobs/create-job-step-2/' + this.latest_job_id + '']);
               
            return true;
       
       
            },
            error => {
            // console.log('Should be form Model' + model);
            // console.error('Error Creating a Trace Project!');
              this.toastr.error('Saving Action List Failed :: Please try again!');
             //  console.log(Observable.throw(error));
             return console.log(error);
            }
       );
       }
  

// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



// Log Filter
searchGridColLogTypeName(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // console.log('Packing');
  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['log_type_name'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}




}
